export default {
  'forgotPassSuccess.title': 'Your request is received!',
  'forgotPassSuccess.sub.title':
    'An email with instructions to reset your password has been sent to your registered email address.',
  'forgotPassSuccess.sub.title1':
    "If you do not receive the email within the next few minutes, please check your email account's Junk/Spam folder.",
  'forgotPassSuccess.button.signIn': 'OK',
};
